import { render, staticRenderFns } from "./TabelaRespostas.vue?vue&type=template&id=7d120cae&scoped=true"
import script from "./TabelaRespostas.vue?vue&type=script&lang=ts"
export * from "./TabelaRespostas.vue?vue&type=script&lang=ts"
import style0 from "./TabelaRespostas.vue?vue&type=style&index=0&id=7d120cae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d120cae",
  null
  
)

export default component.exports